import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mailchimp = defineConnector({
  identifier: "mailchimp",
  name: "Mailchimp",
  tagLine: "Email marketing platform",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://.*\\.api\\.mailchimp\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: "anystring",
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get your Mailchimp API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Mailchimp Account](https://us1.admin.mailchimp.com/account/api/) and create or copy an API key.\n\nThe API key includes your data center (e.g., `us21`) at the end after the hyphen.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Data center",
          placeholder: "us21",
          required: true,
          target: { kind: "configuration", field: "dataCenter" },
          helperText:
            "The suffix after the dash in your API key (e.g., `us21` from `…-us21`).",
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-us21",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "Your API key includes the data center suffix (e.g., -us21).",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ dataCenter }) =>
      `https://${dataCenter}.api.mailchimp.com/3.0/ping`,
  },
  publicEnvVars: ({ dataCenter }) => ({
    MAILCHIMP_DATA_CENTER: dataCenter || "",
  }),
});
